import { connect } from 'react-redux';
import { onChangeClasses, onChangeInformation } from './../../../../../actions/addOrder';
import ShipmentOptionsComponent from './../../../components/shipment-options';
import './styles.css';

class ShipmentOptions extends ShipmentOptionsComponent {
    constructor(props) {
        super(props)
    }
}

const mapStateToProps = state => {
    return {
        classes: state.addOrder.classes,
        information: state.addOrder.information,
        shipperInformation: state.addOrder.shipperInformation,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onChangeInformation: payload => {
            dispatch(onChangeInformation(payload))
        },
        onChangeClasses: payload => {
            dispatch(onChangeClasses(payload))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ShipmentOptions)




// WEBPACK FOOTER //
// ./src/containers/orders/add/components/shipment-options/index.js